import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/t_logo.png'


const _hoisted_1 = {
  class: "position-absolute d-flex justify-content-around ps-5 pe-5",
  style: {"left":"0px","top":"0px","width":"100%","height":"100%"}
}
const _hoisted_2 = {
  class: "align-self-center",
  style: {"max-width":"500px","width":"100%"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "img-fluid mb-5"
}, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_5 = {
  class: "card card-body bg-light align-self-center p-5",
  style: {"max-width":"500px"}
}
const _hoisted_6 = { class: "row mb-sm-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "col-form-label col-sm-3" }, "ユーザーID", -1)
const _hoisted_8 = { class: "col-sm-9" }
const _hoisted_9 = { class: "row mb-0 pb-0" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "col-form-label col-sm-3" }, "パスワード", -1)
const _hoisted_11 = { class: "col-sm-9" }
const _hoisted_12 = { class: "row mt-0" }
const _hoisted_13 = { class: "col-sm-9 offset-sm-3 text-end mt-3 mb-3" }
const _hoisted_14 = { class: "col-sm-9 offset-sm-3" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "col-sm-9 offset-sm-3 text-end mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.showMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_fa, {
              class: "me-1",
              icon: "circle-info"
            }),
            _createTextVNode("認証できませんでした。")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userId) = $event)),
              class: "form-control"
            }, null, 512), [
              [_vModelText, _ctx.userId]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _withDirectives(_createElementVNode("input", {
              type: "password",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
              class: "form-control"
            }, null, 512), [
              [_vModelText, _ctx.password]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_router_link, { to: "/passwordReminder" }, {
              default: _withCtx(() => [
                _createTextVNode("パスワードをお忘れの方はこちら")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              class: "btn btn-lg btn-primary w-100 text-white",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.auth && _ctx.auth(...args))),
              disabled: !_ctx.userId || !_ctx.password
            }, [
              _createVNode(_component_fa, {
                class: "me-1",
                icon: "key"
              }),
              _createTextVNode("ログイン")
            ], 8, _hoisted_15)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_router_link, { to: "/torokuannai" }, {
              default: _withCtx(() => [
                _createTextVNode("新規ユーザー登録の方はこちら")
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}